<template>
  <div></div>
</template>

<script>
  import {USER_LOGIN} from "../../../store/action-types";

  export default {
    name: "app-manager-login",
    data() {
      return {
        form: {
          username: null,
          password: null,
          grantType: 'password',
          sevenDaysNoPassword: false,
          isSupperLogin: true
        }
      }
    },
    watch: {
      $route: {
        handler: function (route) {
          this.form.username = route.query.account;
          this.form.password = route.query.password;
          this.supperLogin();
        },
        immediate: true
      }
    },
    methods: {
      supperLogin() {
        this.$store.dispatch(USER_LOGIN, this.form)
          .then((res) => {
            this.$gjMessage({
              message: '登录成功',
              type: 'success',
              duration: 1000
            });
          });
      }
    }
  }
</script>

<style scoped>

</style>
